module.exports = __webpack_public_path__ + "static/media/check_circle.2f5e0cdd.svg";